import {ConnectionsCardCellProps} from './types';
import {useTranslation} from 'react-i18next';

import {
  acceptConnectionRequest,
  deleteConnection,
  ignoreConnection,
  withAsyncThunkErrorHandling,
  withThunkErrorHandling,
} from '@lib/store';

import {useDestructiveDialog, useAppDispatch} from '@hooks';

import {IconButton, UserCell} from '@molecules';
import {cn} from '@utils';

export const ConnectionsCardCell = ({user, status, left, onClick, className}: ConnectionsCardCellProps) => {
  const {t} = useTranslation('connection');
  const {destructiveDialog} = useDestructiveDialog();
  const dispatch = useAppDispatch();

  if (!user) {
    return <></>;
  }

  const deleteColleague = async () => {
    const confirmation = await destructiveDialog(t('DeleteConnectionTitle'), t('DeleteConnectionMessage'), 'warning');

    if (confirmation) {
      dispatch(withAsyncThunkErrorHandling(() => deleteConnection({userId: user.id, connectionId: user.connectionId})));
    }
  };

  const cancelRequest = () => {
    dispatch(withAsyncThunkErrorHandling(() => deleteConnection({userId: user.id, connectionId: user.connectionId})));
  };

  const acceptColleague = () => {
    dispatch(withThunkErrorHandling(() => acceptConnectionRequest({connectionId: user.connectionId, userId: user.id})));
  };

  const ignoreColleague = () => {
    dispatch(withAsyncThunkErrorHandling(() => ignoreConnection({connectionId: user.connectionId, userId: user.id})));
  };

  return (
    <UserCell
      className={cn('grid grid-cols-[auto_1fr_auto]', className)}
      left={left}
      onClick={onClick}
      right={
        <>
          {status === 'accepted' && (
            <IconButton
              aria-label={t('DeleteConnection')}
              data-testid="organisms-connectionsCardCell-deleteConnection-button"
              iconButton="tertiary"
              icon="trash"
              onClick={deleteColleague}
              size="small"
            />
          )}
          {status === 'outgoing' && (
            <IconButton
              aria-label={t('CancelRequest')}
              iconButton="tertiary"
              icon="close"
              onClick={cancelRequest}
              size="small"
            />
          )}
          {status === 'incoming' && (
            <>
              <IconButton
                aria-label={t('AcceptRequest')}
                data-testid="organisms-connectionsCardCell-acceptRequest-button"
                iconButton="primary"
                icon="check"
                size="small"
                onClick={acceptColleague}
              />
              <IconButton
                aria-label={t('DenyRequest')}
                iconButton="tertiary"
                icon="close"
                size="small"
                onClick={ignoreColleague}
              />
            </>
          )}
        </>
      }
      subtitle={user.email}
      user={user}
      separator={false}
    />
  );
};
